<div class="w-full">
	<div class="w-full">
		<div
			class="field max-w-40rem"
			pTooltip="{{'nomenclature.nomenclature_search_tooltip' | translate}}"
			tooltipStyleClass="max-w-30rem" showDelay="500" tooltipPosition="top"
		>
			<label for="nomemclature">{{'nomenclature.filter_label'|translate}}</label>
			<nomenclature-selector
				*ngIf="mergedNomenclatureDiagnostics"
				name="nomemclature"
				[nomenclature]="mergedNomenclatureDiagnostics"
				[initialSelectionKey]="nomenclature_selection_key"
				[(ngModel)]="nomenclatureFilter"
				(onSelectionChange)="nomenclatureSelectionChange($event)"
				placeholder="{{'common.selector_placeholder' | translate}}"
				[treeSelect]="true"
				[excludeRubriques]="true"
			></nomenclature-selector>
		</div>
	</div>

	<ng-container *ngIf="!loading && statistiquesConformite">
		<div class="w-full" *ngIf="statistiquesConformite.sites.length == 1">
			<bloc-statistiques 
				class="block w-12" 
				[statistiques]="statistiquesConformite.sites[0]" 
				[isBlockAlone]="true"
				[nomenclatureSelectionKey]="nomenclature_selection_key" 
			>
			</bloc-statistiques>
		</div>

		<div *ngIf="statistiquesConformite.sites.length > 1" class="p-fluid grid">
			<!-- Global -->
			<bloc-statistiques 
				class="block col-12" 
				[statistiques]="statistiquesConformite.total"
				[nomenclatureSelectionKey]="nomenclature_selection_key"
			>
			</bloc-statistiques>

			<!-- Sites -->
			<bloc-statistiques 
				*ngFor="let stats of statistiquesConformite.sites" 
				class="block col-12 xl:col-6" 
				[statistiques]="stats"
				[nomenclatureSelectionKey]="nomenclature_selection_key" 
			>
			</bloc-statistiques>
		</div>
	</ng-container>

	<ng-container *ngIf="loading">
		{{'common.loading' | translate}}
	</ng-container>
</div>

<div *ngIf="!statistiquesConformite && !loading" class="w-full">
	{{'dashboard.no_access' | translate}}
</div>
